import { Group, SegmentedControl, Select } from '@mantine/core'

import type { EscopoWhatsApiState } from '@/hooks/useEscopoWhatsApi'

/**
 * Seletores de escopo das telas do WhatsApi (spec 2026-10-23 §5.3): "Tenant |
 * Organização" só para quem tem os dois, e a organização só com mais de uma.
 * A escolha é da tela; o seletor global do menu não muda.
 */
export function SeletorEscopo({
  escopo, opcoes, escolher,
}: Pick<EscopoWhatsApiState, 'escopo' | 'opcoes' | 'escolher'>) {
  const comTenantEOrg = opcoes.tenant && opcoes.organizacoes.length > 0
  const orgAtual = escopo.tipo === 'organizacao' ? escopo.orgId : null
  const comVariasOrgs = orgAtual != null && opcoes.organizacoes.length > 1
  if (!comTenantEOrg && !comVariasOrgs) return null

  return (
    <Group gap="xs" wrap="wrap">
      {comTenantEOrg && (
        <SegmentedControl
          size="sm"
          aria-label="Escopo do WhatsApi"
          value={orgAtual != null ? 'organizacao' : 'tenant'}
          onChange={(v) => escolher(v === 'organizacao' ? 'organizacao' : 'tenant')}
          data={[
            { value: 'tenant', label: 'Tenant' },
            { value: 'organizacao', label: 'Organização' },
          ]}
        />
      )}
      {comVariasOrgs && (
        <Select
          size="sm"
          aria-label="Organização do WhatsApi"
          value={String(orgAtual)}
          onChange={(v) => { if (v) escolher('organizacao', Number(v)) }}
          data={opcoes.organizacoes.map((o) => ({ value: String(o.id), label: o.name }))}
          allowDeselect={false}
          w={240}
        />
      )}
    </Group>
  )
}
